<template>
  <Page class="d-flex align-items-center">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4 d-flex justify-content-center align-items-center">
          <img src="@/assets/logo.png" alt="App logo">
        </div>
        <div class="col-md-5 d-flex align-items-center">
          <div class="card borderless py-3" style="border-radius:0; border:none">
            <div class="card-body p-1">
              <h1 class="card-title mb-3 text-dark text-uppercase" style="font-weight:700"><span
                  style="color: #0092f7">Log</span> In</h1>

              <form @submit.prevent="login">
                <div class="row">
                  <div class="col">
                    <div class="form-floating mb-3">
                      <input type="text" class="form-control" v-model="username" id="floatingTextInput1"
                             placeholder="Username" required>
                      <label for="floatingTextInput1">Username</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-floating mb-3">
                      <input class="form-control" v-model="password"
                             id="floatingPasswordInput" :type="passwordFieldType"
                             placeholder="Password" required>
                      <label for="floatingPasswordInput">Password</label>
                    </div>
                  </div>
                </div>
                <label class="show-password-checkbox">
                  <input type="checkbox" v-model="show_password">
                  Show Password
                </label>
                <div class="text-center">
                  <p class="text-danger">{{ warning }}</p>
                  <button :disabled="loading" type="submit" class="btn">
                    Login
                    <span v-if="loading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-md-3"></div>
      </div>
    </div>
  </Page>
</template>

<script>

import Page from '@/components/layout/Page.vue';

export default {
  name: "LoginView",
  components: {Page},
  async beforeMount() {
    let device = await Device.getDeviceId();
    localStorage.clear();
    localStorage.setItem('deviceRegistrationID', device)
  },
  computed: {
    passwordFieldType() {
      return this.show_password ? 'text' : 'password';
    },
  },
  data() {
    return {
      setup: true,
      username: '',
      password: '',
      loading: false,
      warning: '',
      show_password: false
    }
  },
  methods: {
    login() {
      this.loading = true;
      return this.$store.dispatch('appLogin', {
        email: this.username,
        password: this.password,
      }).then(() => this.$router.push({name: 'select-store'}))
          .catch(err => this.warning = err)
          .finally(() => this.loading = false)
    },
  }
}
</script>

<style scoped>
.row {
  height: 100%;
}

.container-fluid {
  height: 100vh;
  overflow-y: auto
}

.btn,
.btn:hover {
  background: linear-gradient(90deg, rgba(65, 105, 225, 1) 0%, rgba(30, 144, 255, 1) 100%);
  color: white;
  font-weight: 600;
  display: block;
  width: 100%;
  height: 45px;
}

.card {
  padding-left: 10px;
  padding-right: 10px;
  width: 100%;
  /* max-width: 95vw; */
  /* margin-top: -3rem !important; */
}

.show-password-checkbox {
  margin-bottom: 20px;
}
</style>
